<template>
  <!-- 验厂 -->
  <div class="reportBasic">
    <div class="reportBasic-con">
      <a-spin :spinning="spinning">
        <a-tabs defaultActiveKey="1" @change="callback">
          <a-tab-pane
            :tab="$tc('lang.factoryReport.General_Information')"
            key="1"
          >
            <basic-information />
          </a-tab-pane>
          <a-tab-pane
            :tab="$tc('lang.factoryReport.Production_Capability')"
            key="2"
          >
            <description-of-goods />
          </a-tab-pane>
          <a-tab-pane
            :tab="$tc('lang.factoryReport.Workshop_Plant_Overview')"
            key="3"
          >
            <description-of-pack />
          </a-tab-pane>
          <a-tab-pane
            :tab="$tc('lang.factoryReport.Equipments_Information')"
            key="4"
          >
            <product-details />
          </a-tab-pane>
          <a-tab-pane
            :tab="$tc('lang.factoryReport.Production_Manufacturing_Process')"
            key="5"
          >
            <cart></cart>
          </a-tab-pane>
          <a-tab-pane
            :tab="$tc('lang.factoryReport.Human_Resourse_Records')"
            key="6"
          >
            <process-monitoring></process-monitoring>
          </a-tab-pane>
          <a-tab-pane
            :tab="$tc('lang.factoryReport.Operation_Records')"
            key="7"
          >
            <closures></closures>
          </a-tab-pane>
          <a-tab-pane :tab="$tc('lang.factoryReport.Conclusion')" key="8">
            <general-estimate />
          </a-tab-pane>
        </a-tabs>
      </a-spin>
    </div>
  </div>
</template>
<script>
import basicInformation from './factoryComponents/basicInformation';
import descriptionOfGoods from './factoryComponents/descriptionOfGoods';
import descriptionOfPack from './factoryComponents/descriptionOfPack';
import productDetails from './factoryComponents/productDetails';
import generalEstimate from './factoryComponents/generalEstimate';
import cart from './factoryComponents/cart';
import processMonitoring from './factoryComponents/processMonitoring';
import closures from './factoryComponents/closures';
export default {
  data() {
    return {
      id: this.$route.query.id,
      spinning: false,
    };
  },
  created() {
    this.getDetail();
  },
  components: {
    descriptionOfGoods, // 货物描述
    descriptionOfPack, // 包装描述
    productDetails, // 产品细节
    cart,
    closures,
    processMonitoring,
    basicInformation, // 基本信息
    generalEstimate, //总概
  },
  computed: {
    factoryDetails: {
      get() {
        return this.$store.state.report.factoryDetails;
      },
      set(val) {
        this.$store.commit('report/save', { factoryDetails: val });
      },
    },
  },
  methods: {
    callback(key) {
      console.log(key);
    },
    goBack() {
      this.$router.back(-1);
    },

    getDetail() {
      this.spinning = true;
      this.$http
        .post('/hzwmj/workorder-factoryreport/seachFactoryreport', {
          id: this.id,
        })
        .then(data => {
          if (data.data) {
            this.factoryDetails = data.data;
            this.spinning = false;
            this.getImg();
          } else {
            this.factoryDetails = {};
            this.spinning = false;
          }
        })
        .catch(() => {
          this.factoryDetails = {};
          this.spinning = false;
        });
    },
    getImg() {
      this.$store.dispatch(
        'report/getfactoryImg',
        this.factoryDetails.freportId,
      );
    },
  },
};
</script>

<style lang="less">
.reportBasic {
  height: calc(100vh - 200px);
  overflow: hidden;
  text-align: left;
  margin-top: 35px;
  li {
    list-style: none;
  }

  .reportBasic-subTitle {
    background-color: #f6f6f6;
    padding: 5px 10px;
    margin: 10px 0;
  }
  .button-group {
    text-align: right;
    button {
      margin: 0 5px;
    }
  }
  .reportBasic-con {
    .ant-tabs-tabpane {
      padding: 0 10px 30px;
      height: calc(100vh - 300px);
      overflow-y: auto;
    }
  }
}
</style>
